<template>
  <div class="toasts-stack" :style="{ '--project-drawer-with': drawerWidths.currentPx }">
    <VSonner position="bottom-center" :offset="40" expand />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { VSonner } from 'vuetify-sonner'

import { useNavigationDrawer } from '@/common/navigation-drawer/useNavigationDrawer'

export default defineComponent({
  name: 'AppToastsStack',
  components: { VSonner },
  setup() {
    const { drawerWidths } = useNavigationDrawer()

    return {
      drawerWidths,
    }
  },
})
</script>

<style lang="scss" scoped>
.toasts-stack {
  display: flex;
  :deep(section) {
    ol[data-sonner-toaster] {
      --navigation-drawer-offset: calc(var(--project-drawer-with) / 2);
      --width: 360px;
      --gap: 8px;
      display: flex;
      align-items: center;
      justify-content: center;

      // Offset the stack by half the navigation drawer width so it stays
      // centered on the visible content area. Only above vue-sonner's mobile
      // breakpoint (max-width: 600px), where the drawer is present; below it
      // we let vue-sonner center the toast edge-to-edge via its own rule.
      @media (min-width: 601px) {
        left: calc(50% + var(--navigation-drawer-offset));
      }

      // On mobile vue-sonner forces the toast item to a near full-width box,
      // which left-aligns our fixed-width (max 320px) toast inside it. Center
      // the toast within that box so it sits centered between the 16px offsets.
      @media (max-width: 600px) {
        [data-sonner-toast] {
          display: flex;
          justify-content: center;
        }
      }
    }
  }
}
</style>
